import React, { useCallback, useEffect, useMemo, useState } from "react";

import { Activate_Role_PUT, All_Role_List_POST, DeActivate_Role_PUT, Delete_Role_DELETE, Deleted_Role_List_POST, Revive_Role_PUT } from "api/ApiConst";
import { handleActive, handleDelete, handleInactive, handleRevive } from "utils/UserUtils";
import dateUtilities from "utils/DateUtilities";

import CustomButton from "components/common/CustomButton";
import PaginationDataTable from "components/common/PaginationDataTable";
import CheckboxButton from "components/common/CheckboxButton";
import PageHeading from "components/common/PageHeading";
import RoleAddEdit from "./RoleAddEdit";
import AssignUrls from "./AssignUrls";

const RoleMaster = () => {
    const [refreshFlag, setRefreshFlag] = useState(0);
    const [viewDeletedList, setViewDeletedList] = useState(false);
    const [recordID, setRecordID] = useState(null);
    const [roleTitle, setRoleTitle] = useState("");
    const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);
    const [showAssignModuleModal, setShowAssignModuleModal] = useState(false);

    useEffect(() => {
        if (!showAddUpdateModal && !showAssignModuleModal) {
            setRecordID(null);
            setRoleTitle("");
        }
    }, [showAddUpdateModal, showAssignModuleModal]);

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);

    const columns = useMemo(
        () => [
            {
                id: "status",
                name: "",
                selector: (row) => <div className={row.active ? "led-green" : "led-red"} title={row.active ? "Active" : "Inactive"} />,
                width: "60px",
                sortable: false,
            },
            {
                id: "title",
                name: "Title",
                selector: (row) => row.title,
                sortable: false,
            },
            {
                id: "createdAt",
                name: "Created Time",
                selector: (row) => dateUtilities.formattedDate(row.createdAt, "dd-MM-yyyy, hh:mm aa"),
                sortable: false,
            },
            {
                id: "action",
                name: "",
                selector: (row) => getActionButtons(row),
                width: "80px",
                sortable: false,
            },
        ],
        [handleRefresh]
    );

    const getActionButtons = (row) => {
        return (
            <div className="d-flex align-items-center justify-content-between">
                {!row.deleted && (
                    <>
                        <button className="listBtn me-2" onClick={() => handleEdit(row)}>
                            <i className="bx bx-pencil"></i>
                        </button>
                    </>
                )}
                <div className="dropdown">
                    <button className="btn btn-primary btn-flat btn-addon btn-xs dropdown-toggle" title="More" data-bs-toggle="dropdown" aria-expanded="false" style={{ padding: "5px 10px 8px 10px" }}>
                        <i className="bx bx-chevron-down"></i>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-right">
                        <>
                            {row.deleted ? (
                                <li onClick={() => handleReviveData(row)}>
                                    <i className="bx bx-log-out-circle"></i> Revive
                                </li>
                            ) : (
                                <>
                                    <li onClick={() => handleDeleteData(row)}>
                                        <i className="bx bx-trash"></i> Delete
                                    </li>
                                    <li onClick={() => handleActiveInactive(row)}>
                                        {row.active ? (
                                            <>
                                                <i className="bx bx-x-circle"></i> Inactive
                                            </>
                                        ) : (
                                            <>
                                                <i className="bx bx-check-circle"></i> Active
                                            </>
                                        )}
                                    </li>
                                    <li onClick={() => handleAssignModule(row)}>
                                        <i className="bx bx-link-alt"></i> Assign Urls
                                    </li>
                                </>
                            )}
                        </>
                    </ul>
                </div>
            </div>
        );
    };

    const handleEdit = (row) => {
        setRecordID(row.uuid);
        setShowAddUpdateModal(true);
    };

    const handleActiveInactive = (row) => {
        if (row.active) {
            handleInactive(DeActivate_Role_PUT.replaceAll("{recordID}", row.uuid), handleRefresh);
        } else {
            handleActive(Activate_Role_PUT.replaceAll("{recordID}", row.uuid), handleRefresh);
        }
    };

    //Delete Record
    const handleDeleteData = (row) => {
        handleDelete(Delete_Role_DELETE.replaceAll("{recordID}", row.uuid), handleRefresh);
    };

    //Revive Record
    const handleReviveData = (row) => {
        handleRevive(Revive_Role_PUT.replaceAll("{recordID}", row.uuid), handleRefresh);
    };

    const handleAssignModule = (row) => {
        setRecordID(row.uuid);
        setRoleTitle(row.title);
        setShowAssignModuleModal(true);
    };

    const handleToggleDeletedView = () => setViewDeletedList(!viewDeletedList);

    return (
        <>
            {PageHeading("Role List", "Dashboard", "/")}
            <div className="card">
                <CustomButton handleClick={() => setShowAddUpdateModal(true)} title="Create New" iconClass="bx bx-plus" buttonClass="createButton" />
                <div className="card-body tableView">
                    <PaginationDataTable paginationUrl={viewDeletedList ? Deleted_Role_List_POST : All_Role_List_POST} serverSidePagination={true} search={true} pagination={false} columns={columns} />
                    <CheckboxButton title="Deleted List" handleClick={handleToggleDeletedView} additionalClass="deletedBtn ml-auto" />
                </div>
            </div>
            {showAddUpdateModal && <RoleAddEdit show={showAddUpdateModal} hideModal={() => setShowAddUpdateModal(false)} recordID={recordID} handleRefresh={handleRefresh} />}
            {showAssignModuleModal && (
                <AssignUrls show={showAssignModuleModal} hideModal={() => setShowAssignModuleModal(false)} recordID={recordID} handleRefresh={handleRefresh} roleTitle={roleTitle} />
            )}
        </>
    );
};

export default RoleMaster;
